import { router, Stack } from 'expo-router';
import { useEffect } from 'react';
import { Platform } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import Customers from '@/components/customers';
import { isDesktop } from '@/core';
import { useHasOrganization } from '@/core/hooks/use-has-organization';

export default function CustomersScreen() {
  const { theme } = useStyles();
  const { hasOrganization, isPending } = useHasOrganization();

  useEffect(() => {
    if (!isPending && !hasOrganization) {
      router.replace('/partner/dashboard');
    }
  }, [isPending, hasOrganization]);

  if (!hasOrganization) {
    return null;
  }

  return (
    <>
      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          options={{
            headerTitle: 'Customers',
            headerLeft: () => null,
            headerBackVisible: false,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}

      <Customers />
    </>
  );
}
